import { defineComponent } from 'vue';
import partner1Image from '@/assets/image/partner/p1@2x.png';
import partner2Image from '@/assets/image/partner/p2@2x.png';
import partner3Image from '@/assets/image/partner/p3@2x.png';
export default defineComponent({
  name: 'HomePartner',
  setup: function () {
    return {
      partner1Image: partner1Image,
      partner2Image: partner2Image,
      partner3Image: partner3Image
    };
  }
});